import { AfterViewInit, Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import {
    EclModalCloseEvent,
    EclModalComponent,
} from '@eui/ecl/components/ecl-modal';

@Component({
    standalone: false,
    selector: 'app-basic-dialog',
    template: '<dialog #_innerModal eclModal></dialog>'
})
export class BasicDialogComponent implements AfterViewInit {

    @ViewChild('_innerModal') modal: EclModalComponent;

    @Output()
    modalClose = new EventEmitter<EclModalCloseEvent>();

    public readonly YES = 'yes';

    private _isOpen: boolean;

    get isOpen(): boolean {
        return this._isOpen;
    }

    @Input()
    set isOpen(value: boolean) {
        this._isOpen = value;
        if(this.modal) {
            this.modal.isOpen = value;
        }
    }

    constructor() {}

    ngAfterViewInit() {
        setTimeout(() => this.modal.isOpen = this._isOpen);
    }

    openModal(): void {
        this.modal.openModal();
    }

    closeModal(result?: EclModalCloseEvent<boolean>): void {
        this.modal.closeModal(result.eclModalResult);
    }
}
